// extracted by mini-css-extract-plugin
module.exports = {"heading":"WebHeading_heading__FoCOz","heading-1":"WebHeading_heading-1__1Y5vB","heading-2":"WebHeading_heading-2__aQ7Mg"};